import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { clinic, navLinks } from "@/data/clinic";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50 border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://chatgpt.com/backend-api/estuary/public_content/enc/eyJpZCI6Im1fNmFiMTZiOGMyNjQ0ODE5MWI1NGMwYmQ0NWI1NmZlYzc6ZmlsZV8wMDAwMDAwMDBhMjg4MWY1YTczZGM0MDUwOTFjZDUwMCIsImdpem1vX2lkIjpudWxsLCJ3aWQiOm51bGwsIm9pZCI6bnVsbCwic2lkIjpudWxsLCJjcyI6bnVsbCwiZm4iOm51bGwsImNkIjpudWxsLCJ0cyI6IjIwNzE3IiwicCI6InB5aSIsImNpZCI6IjEiLCJzaWciOiIyMzM1MGQ1NTdmOWU2OTZiYTY4ODMzMjgwZmFhYjJhZjMwYjVhOWE5N2JhNmRhMzQwYjA0NjJmYWU2MzU3NGMxIiwidiI6IjAiLCJjZG4iOm51bGwsImNwIjpudWxsLCJtYSI6bnVsbH0="
              alt="Florida Family Clinic logo"
              title="Florida Family Clinic"
              className="w-10 h-10 md:w-11 md:h-11 rounded-full object-cover border border-background-200"
            />
            <span className="flex flex-col leading-none">
              <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
                {clinic.brand}
              </span>
              <span className="text-[11px] tracking-[0.14em] uppercase text-secondary-600 mt-1">
                Miami, Florida
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors duration-200 ${
                    isActive
                      ? "text-primary-600"
                      : "text-foreground-700 hover:text-primary-600"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/contact"
              className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors duration-200 hover:bg-primary-600"
            >
              <i className="ri-calendar-check-line" />
              Contact the Clinic
            </Link>
            <button
              type="button"
              aria-label="Toggle navigation menu"
              aria-expanded={open}
              onClick={() => setOpen((prev) => !prev)}
              className="md:hidden w-10 h-10 rounded-md border border-background-300 flex items-center justify-center text-foreground-800 cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <nav className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 ${
                    isActive
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line" />
              Contact the Clinic
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}